import { Component, ComponentFactoryResolver, Input, OnDestroy, OnInit } from '@angular/core';
import { ModalService, ModalSize } from "@cv-invision/core";
import { Subject, takeUntil } from "rxjs";
import { TableDataConfigurationComponent } from "./table-data-configuration/table-data-configuration.component";
import { FormControl } from "@angular/forms";
import { FieldModel } from "@cv-invision/cv.invision-views.ux";

@Component({
	selector: 'cv-modal-table-field',
	templateUrl: './modal-table-field.component.html',
	styleUrls: ['./modal-table-field.component.scss'],
})
export class ModalTableFieldComponent implements OnInit, OnDestroy {
	@Input() fieldOptions: any;
	@Input() control: FormControl;
	@Input() field: FieldModel;
	@Input() value: any;
	childForm: any;

	private atComponentDestroy: Subject<any> = new Subject<any>();

	constructor(
		private modalService: ModalService,
		protected componentFactoryResolver: ComponentFactoryResolver,
	) {
	}

	ngOnInit(): void {
		this.childForm= this.field.UIOptions?.tableConfig?.childForm;
	}

	/**
	 * event to open the modal to show expanse table component
	 */
	openConfigurationData() {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: TableDataConfigurationComponent,
				data: {
					tableData: this.control.value,
					tableConfig: this.field.UIOptions.tableConfig,
					disabled: this.control.disabled,
				},
				modalConfiguration: {
					title: ``,
					modalSize: ModalSize.LG
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if(result?.data){
					const controlData = {}
					result.data?.forEach(item => {
						controlData[item.label] = item.value.map(item => {
							return item.label;
						});
					})

					this.control.setValue(controlData);
				}
			});
	}

	/**
	 * event to call when the component has been destroyed
	 */
	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
